import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {isCreditCardPaymentMethod, PaymentMethod} from '@raisenow/epik'
import {CreditCardForm} from './PaymentMethodForm/CreditCardForm'
import {DirectDebitForm} from './PaymentMethodForm/DirectDebitForm'
import {ElektronischesLastschriftverfahrenForm} from './PaymentMethodForm/ElektronischesLastschriftverfahrenForm'
import {SepaOneForm} from './PaymentMethodForm/SepaOneForm'
import {PaymentSlipForm} from './PaymentMethodForm/PaymentSlipForm'
import {PaymentSlipWithReferenceNumberForm} from './PaymentMethodForm/PaymentSlipWithReferenceNumberForm'
import {PostFinanceForm} from './PaymentMethodForm/PostFinanceForm'
import {SmsForm} from './PaymentMethodForm/SmsForm'
import {PaymentForm} from '../../../../lib/forms/PaymentForm'
import {SubscriptionRenewForm} from '../../../../lib/forms/SubscriptionRenewForm'
import {PaymentMethodInfo} from './PaymentMethodInfo'

///////////////////////////////////////////////////////////////////////////////

type PaymentMethodFormProps = {
  form: PaymentForm | SubscriptionRenewForm
}

///////////////////////////////////////////////////////////////////////////////

export const PaymentMethodForm: FC<PaymentMethodFormProps> = observer(
  (props) => {
    const {form} = props
    const paymentMethod = form.getPaymentMethod()

    if (!paymentMethod) {
      return null
    }

    if (isCreditCardPaymentMethod(paymentMethod)) {
      return <CreditCardForm form={form} />
    }

    if (paymentMethod === PaymentMethod.CYMBA) {
      // todo: check (api error - 500)
    }

    if (paymentMethod === PaymentMethod.DIRECT_DEBIT) {
      return <DirectDebitForm form={form} />
    }

    if (paymentMethod === PaymentMethod.WEBBANKING_INDIA) {
      // no additional fields
    }

    if (paymentMethod === PaymentMethod.ELEKTRONISCHES_LASTSCHRIFTVERFAHREN) {
      return <ElektronischesLastschriftverfahrenForm form={form} />
    }

    if (paymentMethod === PaymentMethod.ELECTRONIC_PAYMENT_SERVICE) {
      // no additional fields
    }

    if (paymentMethod === PaymentMethod.MASTER_PASS) {
      // todo: check (account needed)
    }

    if (paymentMethod === PaymentMethod.PAYMENT_SLIP) {
      // no additional fields
    }

    if (paymentMethod === PaymentMethod.PAYMENT_SLIP_WITH_REFERENCE_NUMBER) {
      return <PaymentSlipWithReferenceNumberForm form={form} />
    }

    if (paymentMethod === PaymentMethod.PAYMENT_SLIP) {
      return <PaymentSlipForm form={form} />
    }

    if (paymentMethod === PaymentMethod.PAY_PAL) {
      // todo: check (account needed)
    }

    if (
      paymentMethod === PaymentMethod.POST_FINANCE ||
      paymentMethod === PaymentMethod.POST_FINANCE_CARD
    ) {
      // todo: check (account needed)
      return <PostFinanceForm form={form} />
    }

    if (paymentMethod === PaymentMethod.SEPA_ONE) {
      return <SepaOneForm form={form} />
    }

    if (paymentMethod === PaymentMethod.SMS) {
      return <SmsForm form={form} />
    }

    if (paymentMethod === PaymentMethod.SOFORT) {
      // todo: check (account needed)
    }

    if (paymentMethod === PaymentMethod.TWINT) {
      // no additional fields
    }

    if (paymentMethod === PaymentMethod.MPOS) {
      // no additional fields
    }

    // default info
    return <PaymentMethodInfo paymentMethod={paymentMethod} />
  },
)
